import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MailCheck, Mail } from "lucide-react";
import { Brand } from "@/components/common";
import { api, errMsg } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message);
    } catch (ex) { setErr(errMsg(ex)); }
    setBusy(false);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 py-12">
      <div className="w-full max-w-sm gt-rise">
        <Brand className="mb-10" />
        {msg ? (
          <div className="gt-card p-6" data-testid="forgot-success">
            <MailCheck className="h-10 w-10 text-emerald-500" />
            <h2 className="mt-3 text-xl font-extrabold">Cek email Anda</h2>
            <p className="mt-2 text-sm text-muted-foreground">{msg} Link berlaku 1 jam.</p>
            <Link to="/login" className="mt-5 inline-block rounded-xl bg-primary px-5 py-2.5 text-sm font-bold text-primary-foreground" data-testid="forgot-to-login">Kembali ke halaman masuk</Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form">
            <div className="gt-eyebrow mb-3">Lupa password</div>
            <h2 className="text-3xl font-extrabold tracking-tight">Atur ulang password</h2>
            <p className="mt-2 text-sm text-muted-foreground">Masukkan email akun Anda. Kami kirimkan link untuk membuat password baru.</p>
            <div className="mt-7 space-y-4">
              <div className="relative">
                <Mail className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="gt-input h-12 pl-10" placeholder="nama@perusahaan.com" data-testid="forgot-email-input" />
              </div>
              {err && <div className="rounded-xl border border-red-500/40 bg-red-500/10 px-3 py-2 text-sm text-red-500" data-testid="forgot-error">{err}</div>}
              <button disabled={busy} className="h-12 w-full rounded-xl bg-primary font-bold text-primary-foreground transition-opacity hover:opacity-95 disabled:opacity-60" data-testid="forgot-submit-button">
                {busy ? "Mengirim..." : "Kirim link reset"}
              </button>
            </div>
            <Link to="/login" className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-muted-foreground hover:text-foreground" data-testid="forgot-back-login"><ArrowLeft className="h-4 w-4" /> Kembali ke halaman masuk</Link>
          </form>
        )}
      </div>
    </div>
  );
}
